import { forwardRef } from 'react';
import { Form as AntdForm } from 'antd';
import './Form.module.css';

/** @param {Object} props - Same shape as antd's own `Form`, forwarded as-is. */
const Form = forwardRef((props, ref) => <AntdForm ref={ref} {...props} />);
Form.displayName = 'Form';

/** @param {Object} props - Same shape as antd's own `Form.Item`, forwarded as-is. */
const FormItem = forwardRef((props, ref) => <AntdForm.Item ref={ref} {...props} />);
FormItem.displayName = 'Form.Item';

Form.Item = FormItem;
Form.List = AntdForm.List;
Form.ErrorList = AntdForm.ErrorList;
Form.Provider = AntdForm.Provider;
Form.useForm = AntdForm.useForm;
Form.useFormInstance = AntdForm.useFormInstance;
Form.useWatch = AntdForm.useWatch;

export default Form;
